import React, { Component } from 'react'
import axios from 'axios'
import { SERVER_LISTING, DELETE_SERVER_URL, SERVER_TOGGAL, LOGIN_URL } from '../../../config/rest_endpoints'
import { getUser } from '../../../actions/session'
import { Notifications } from '../../common/notification';
import CustomLoader from '../../common/loader';
import CustomModal from '../../common/modal'
import Switch from "react-switch";
import AddServer from './components-modal/addServer';
import EditServerConfig from './components-modal/updateServerConfig';
import { RC_LOAD_LOGIN } from '../../routers/RouteConstants';
import { withRouter } from 'react-router-dom';


class ServerConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            accountID: this.props.userId,
            serverList: [],
            isGetting: false,
            isModal: false,
            isDelModal: false,
            delIp: null,
            msg: '',
            name:'',
            updateMsg: '',
            isEditModal: false,
            previousData: [],
            isDelLoad:false
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.serverListing = this.serverListing.bind(this)
        this.delcloseModal = this.delcloseModal.bind(this)
        this.delopenModal = this.delopenModal.bind(this)
        this.deleteServer = this.deleteServer.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
    }

    componentDidMount() {
        this.serverListing()
    }

    closeModal() {
        this.setState({ isModal: false })
    }
    openModal() {
        this.setState({ isModal: true })
    }
    openEditModal(row) {
        this.setState({
            isEditModal: true,
            previousData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false
        })
    }

    delcloseModal() {
        this.setState({ isDelModal: false })
    }
    delopenModal(ip) {
        this.setState({
            isDelModal: true,
            delIp: ip.id
        })
        console.log('ip :>> ', ip);
    }

    toggleSwitch(row) {
        const { User, accountID } = this.state
        var user = row;
        const data = {
            "ip": row.ip,
            "port": row.port,
            "mask": row.mask,
            "active": !user.status
        }
        var headers = { "Authorization": "Bearer " + User.token };
        axios.put(`${SERVER_TOGGAL}/${accountID}/server/${row.id}/update`, data, { headers }).then(res => {
            if (res) {
                this.setState({
                    updateMsg: res.data.message
                })
                this.serverListing()
                Notifications.notify(this.state.updateMsg, "Success", "success");
            }
        }).catch(err => {
            console.log('err :>> ', err);
            Notifications.notify("Failed to fetch", "Failed", "errors")

        })

    }

    serverListing() {
        const { User, accountID } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(`${SERVER_LISTING}/${accountID}/server?page=1&limit=50`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    serverList: res.data.data,
                    isGetting: false
                })
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    renderServerListing() {
        const { serverList } = this.state
        console.log(serverList)
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (serverList === null) {
            return nullData
        }
        else {
            return serverList.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.ip}</td>
                        <td style={{textAlign:'center'}}>{row.techPrefix}</td>
                        <td style={{textAlign:'center'}}>{row.mask}</td>
                        <td style={{textAlign:'center'}}>{row.port}</td>
                        <td style={{textAlign:'center'}}>{row.enabled === false ? <span style={{display:'inline-flex',alignItems:'center',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'600',background:'#FEF2F2',color:'#DC2626'}}>No</span> : <span style={{display:'inline-flex',alignItems:'center',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'600',background:'#ECFDF5',color:'#047857'}}>Yes</span>}</td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.active} /></span></td> */}
                        <td className='edit-button'><i className=" fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)} ></i><i className="text-danger fa fa-trash" aria-hidden="true" onClick={this.delopenModal.bind(this, row)}></i></td>
                    </tr>
                )
            })
        }
    }

    deleteServer() {
        const { accountID, User, delIp } = this.state
        console.log('delIp :>> ', delIp);
        var headers = { "Authorization": "Bearer " + User.token };
        this.setState({isDelLoad:true})
        axios.delete(`${DELETE_SERVER_URL}/${accountID}/server/${delIp}/delete`, { headers }).then(res => {
            if (res) {
                this.setState({
                    msg: res.data.message,
                    isDelLoad:false
                })
                this.delcloseModal()
                this.serverListing()
                Notifications.notify(this.state.msg, "Success", "success")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    render() {
        const { isGetting, isModal, accountID, isDelModal, isEditModal, previousData, isDelLoad } = this.state
        let addServerModal = {
            details: {
                info: "Add Server",
                msg: <AddServer close={this.closeModal} accountID={accountID} listingServer={this.serverListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeModal },
            cancelBtn: { label: "Cancel", action: this.closeModal }
        }
        let editServer = {
            details: {
                info: "Update Server",
                msg: <EditServerConfig mainID={this.state.accountID} previousDetails={previousData} serverListing={this.serverListing} close={this.closeEditModal} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }

        var delModal = (
            <div>
                <div style={{padding:'16px 0'}}>
                    <p style={{fontSize:'13px',color:'#475569',margin:0}}>Are you sure you want to delete this server? This action cannot be undone.</p>
                </div>
                <div style={{display:'flex',justifyContent:'flex-end',gap:'10px',borderTop:'1px solid #E2E8F0',paddingTop:'16px'}}>
                    <button type="button" onClick={this.delcloseModal} style={{background:'#F1F5F9',color:'#475569',border:'1px solid #E2E8F0',borderRadius:'10px',padding:'9px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer'}}>Cancel</button>
                    <button type="button" onClick={this.deleteServer} disabled={this.state.isDelLoad} style={{background:this.state.isDelLoad?'#94A3B8':'#EF4444',color:'#FFFFFF',border:'none',borderRadius:'10px',padding:'9px 20px',fontSize:'13px',fontWeight:'600',cursor:this.state.isDelLoad?'not-allowed':'pointer',display:'inline-flex',alignItems:'center',gap:'8px'}}>
                        {this.state.isDelLoad ? <><i className="icon-spinner4 spinner" style={{fontSize:'14px'}}></i> Deleting...</> : 'Confirm Delete'}
                    </button>
                </div>
            </div>
        )
        let delServerModal = {
            details: {
                info: "Delete Server",
                msg: delModal
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.delcloseModal },
            cancelBtn: { label: "Cancel", action: this.delcloseModal }
        }
        return (
            <div>
                <CustomModal
                    visibility={isModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addServerModal.details}
                    showBtns={false}
                    cancelBtn={addServerModal.cancelBtn}
                    crossBtn={addServerModal.crossBtn}
                />
                <CustomModal
                    visibility={isEditModal}
                    modalType={"success"}
                    modalHeader={'success'}
                    details={editServer.details}
                    showBtns={false}
                    cancelBtn={editServer.cancelBtn}
                    crossBtn={editServer.crossBtn}
                />
                <CustomModal
                    visibility={isDelModal}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={delServerModal.details}
                    showBtns={false}
                    cancelBtn={delServerModal.cancelBtn}
                    crossBtn={delServerModal.crossBtn}
                />
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                        <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Server Configuration</h5>
                        <button type="button" onClick={this.openModal} style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#FFFFFF',border:'none',borderRadius:'10px',padding:'8px 18px',fontSize:'13px',fontWeight:'600',cursor:'pointer',display:'inline-flex',alignItems:'center',gap:'8px',boxShadow:'0 4px 12px rgba(16, 185, 129, 0.3)'}}>
                            Add Server <i className="fas fa-plus" style={{fontSize:'11px'}}></i>
                        </button>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Source IP</th>
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Tech Prefix</th>
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Mask</th>
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Port</th>
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Enabled</th>
                                        <th style={{color:'#475569',borderBottom:'2px solid #E2E8F0',fontSize:'12px',fontWeight:'600',textAlign:'center',textTransform:'uppercase',letterSpacing:'0.05em',padding:'12px 16px'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderServerListing()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(ServerConfig)